import { ColumnTable } from '@octano/global-ui';
import { useTranslation } from 'react-i18next';
import { TranslationsKeys } from '../../../../../../locales/translations';
import { AssignedStudent } from '../types';
import { Input } from 'reactstrap';
import { useSharedData } from './useSharedData';
import { validate, format } from 'rut.js';
export default function useColumns(): ColumnTable<AssignedStudent>[] {
  const { t } = useTranslation(
    TranslationsKeys.TEACHER_MANAGMENT_TEACHER_FILE_ASSIGNED_STUDENTS,
  );
  const { unassigned, updateData } = useSharedData();

  return [
    {
      columnName: 'nameAndId',
      headerText: t('table.nameAndId'),
      thClassName: 'text-center',
      cellFormat: ({ row }) => {
        return (
          <div className="d-flex flex-column align-items-center">
            <p className="m-0">{row.name}</p>
            <p className="m-0">
              {validate(row.identification)
                ? format(row.identification)
                : row.identification}
            </p>
          </div>
        );
      },
    },
    {
      columnName: 'schoolName',
      headerText: t('table.schoolName'),
      tdClassName: 'text-center',
      thClassName: 'text-center',
    },
    {
      columnName: 'studyPlanVersionName',
      headerText: t('table.studyPlanVersionName'),
      tdClassName: 'text-center',
      thClassName: 'text-center',
    },
    {
      columnName: 'campusName',
      headerText: t('table.campusName'),
      tdClassName: 'text-center',
      thClassName: 'text-center',
    },
    {
      columnName: 'scheduleName',
      headerText: t('table.scheduleName'),
      tdClassName: 'text-center',
      thClassName: 'text-center',
    },

    {
      columnName: 'unassign',
      headerText: t('table.unassign'),
      thClassName: 'text-center',
      tdClassName: 'text-center',
      cellFormat: (options) => {
        return (
          <>
            <div className="form-group">
              <label className="g-checkbox-input-container">
                <Input
                  className="g-checkbox-input"
                  type="checkbox"
                  defaultChecked={unassigned.includes(options.row.enrollmentId)}
                  id={`assignment-${options.row.enrollmentId}`}
                  onChange={() => {
                    if (unassigned.includes(options.row.enrollmentId)) {
                      updateData({
                        unassigned: unassigned.filter(
                          (id) => id !== options.row.enrollmentId,
                        ),
                      });
                    } else {
                      updateData({
                        unassigned: [...unassigned, options.row.enrollmentId],
                      });
                    }
                  }}
                />
                <span className="checkmark"></span>
              </label>
              <small className="g-input-error form-text text-danger"></small>
            </div>
          </>
        );
      },
    },
  ];
}
